import { render } from "./SwapTree.vue?vue&type=template&id=700b263d&scoped=true"
import script from "./SwapTree.vue?vue&type=script&lang=js"
export * from "./SwapTree.vue?vue&type=script&lang=js"

import "./SwapTree.vue?vue&type=style&index=0&id=700b263d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-700b263d"]])

export default __exports__